<template>
  <div>
    <NavTop :parentData="this.$route.params.tabBarId" class="navbar">
    </NavTop>
    <!-- 内容 -->
    <div class=" box">
      <div class="box_ content">
        <div class="box_l">
          <div class="box_l_t">
            {{ title.childName }}
          </div>
          <div class="box_l_con">
            <ul>
              <li v-for="(item,index) in title.articleList" :key="index">
                <div class="box_l_con_left">
                  <p style="text-align: center">{{ item.publishTime.split('-')[1] }}</p>
                  <p>{{ item.publishTime.slice(0, 7) }}</p>
                </div>
                <div class="box_l_con_right">
                  <span v-if="title.appointTabId == null"
                        @click="routerpush(title.parentId,item.tabBarId,item.id)">{{ item.title }}</span>
                  <span v-else @click="routerpushSpan(title.appointTabId, item.id)">{{ item.title }}</span>
                </div>
              </li>
            </ul>

          </div>
          <!--         查看更多-->
          <div style="width: 80%; height: 50rpx;margin-left: 40px;">
            <button @click="goGengD(title.parentId, title.id)"
                    style="cursor: pointer; width: 100%;height:40px;background-color: rgb(170, 19, 26);color: white;outline: none;border: 0;border-radius: 5px">
              <span>查看更多</span>
              >
            </button>
          </div>
        </div>
        <div class="box_r">
          <div class="box_r_title">
            <span>{{ renCaiData.childName }}</span>
            <span v-if="renCaiData.appointTabId != null" @click="goTiaoZhuan(renCaiData.appointTabId)">
              查看更多
            </span>
            <span v-else @click="goTiaoZhuanSpan(renCaiData.parentId,renCaiData.id)">查看更多</span>
          </div>
          <div class="box_r_con">
            <ul>
              <li v-for="(item,index) in renCaiData.articleList" :key="index">
                  <span class="notice_con_list_ul_li_a1" v-if="title.appointTabId == null"
                        @click="routerpush(title.parentId,item.tabBarId,item.id)">
                  {{ item.title }}</span>
                <span v-else @click="routerpushSpan(title.appointTabId, item1.id)">{{ item.title }}</span>
                <span class="list_ul_li_span">{{ extractDate(item.publishTime) }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 中间数据 -->
    <div class="mid content">
      <div class="mid_" v-for="(item,index) in moiData" :key="index">
        <div class="mid_title">
          <span>{{ item.childName }}</span>
          <span v-if="item.appointTabId != null" @click="goTiaoZhuan(item.appointTabId)">
              查看更多
            </span>
          <span v-else @click="goTiaoZhuanSpan(item.parentId,item.id)">查看更多</span>
        </div>
        <div class="mid_list">
          <ul>
            <li v-for="(item1,index1) in item.articleList" :key="index1">
              <span v-if="title.appointTabId == null" @click="routerpush(title.parentId,item1.tabBarId,item1.id)">
                  {{ item1.title }}</span>
              <span v-else @click="routerpushSpan(title.appointTabId, item1.id)">{{ item1.title }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import child from '../../api/child'

export default {
  data () {
    return {
      // 通知公獒数据
      title: [],
      // 人才引进数据
      renCaiData: [],
      // 中间数据
      moiData: []
    }
  },
  created () {
    this.getWenZhang(this.$route.params.tabBarId)
    // this.getNav(this.$route.params.tabBarId)
  },
  methods: {
    async getWenZhang (tabBarId) {
      const res = await child.getChild({tabBarId: tabBarId})
      if (res.code == 200) {
        const data = res.data
        console.log(data)
        this.title = data[0]
        // 支部建设数据
        this.renCaiData = data[1]
        console.log(this.zhibuData)
        // 团学活动数据
        this.moiData = data.slice(2, 5)
      }
    },
    extractDate (dateTimeStr) {
      // 使用空格分割日期和时间
      const parts = dateTimeStr.split(' ')
      // 返回日期部分
      return parts[0]
    },
    goGengD (parentId, id) {
      this.$router.push({
        path: '/common/section/more' + '/' + parentId + '/' + id
      })
    },
    // 点击上方查看更多
    goTiaoZhuan (appointTabId) {
      let encodedId = encodeURIComponent(appointTabId)
      let decodedId = decodeURIComponent(encodedId)
      this.$router.push('/common/section/more' + decodedId)
    },
    goTiaoZhuanSpan (parentId, id) {
      this.$router.push('/common/section/more' + '/' + parentId + '/' + id)
    },
    routerpush (parentId, tabBarId, id) {
      this.$router.push('/common/section/detail' + '/' + parentId + '/' + tabBarId + '/' + id)
    },
    routerpushSpan (appointTabId, id) {
      let encodedId = encodeURIComponent(appointTabId)
      let decodedId = decodeURIComponent(encodedId)
      this.$router.push('/common/section/detail' + decodedId + '/' + id)
    },

  }

}
</script>
<style lang="less" scoped>
.content {
  width: 1200px;
  margin: 0 auto;
}

// 内容
.box {
  background: #f9f9f9;
  padding-top: 40px !important;
  .box_ {
    padding-top: 40px;
    padding-bottom: 40px;
    height: 430px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .box_l {
      width: 375px;
      height: 415px;
      border: 1px solid #eee;
      background: #fff;

      .box_l_t {
        font-size: 28px;
        text-align: center;
        font-weight: bold;
        position: relative;
        margin-top: 30px;
        padding-bottom: 10px;
        color: #333;

        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 50%;
          width: 55px;
          height: 2px;
          background: #9e070e;
          margin-left: -27.5px;
        }
      }

      .box_l_con {
        width: 375px;
        height: 280px;
        overflow: hidden;

        ul {
          width: 100%;
          height: 100%;

          li {
            padding: 20px;
            display: flex;
            justify-content: space-between;

            .box_l_con_left {
              padding: 0 10px 0 0;
              border-right: 1px solid #eee;
              width: 65px;

              p {
                &:nth-child(1) {
                  font-size: 24px;
                  color: #666;
                  text-align: center;
                }

                &:nth-child(2) {
                  font-size: 12px;
                  color: #666;
                  text-align: center;
                  width: 65px;
                  line-height: 24px;
                }
              }
            }

            .box_l_con_right {
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
              height: 45px;
              line-height: 24px;
              padding-left: 15px;

              span {
                color: #333;

                &:hover {
                  cursor: pointer;
                  color: #AB070E;
                }
              }
            }
          }
        }
      }
    }

    .box_r {
      width: 785px;
      height: 415px;
      border: 1px solid #eee;
      background: #fff;

      .box_r_title {
        height: 88px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
          &:nth-child(1) {
            font-size: 28px;
            color: #333;
            font-weight: bold;
            position: relative;
            padding: 10px 0;

            &::after {
              content: "";
              position: absolute;
              left: 0;
              width: 59px;
              height: 2px;
              background: #9e070e;
              bottom: 0px;
            }
          }

          &:nth-child(2) {
            position: relative;
            text-decoration: none;
            font-size: 14px;

            &:hover {
              cursor: pointer;
            }

            &::after {
              content: "";
              position: absolute;
              width: 8px;
              height: 8px;
              border: 1px solid #666;
              border-left: none;
              border-bottom: none;
              transform: rotate(45deg);
              top: 50%;
              margin-top: -4px;
            }
          }
        }
      }

      .box_r_con {
        height: 315px;
        overflow: hidden;

        ul {
          width: 100%;
          height: 100%;

          li {
            padding: 0 20px 0 40px;
            position: relative;
            height: 52px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            &::before {
              content: "";
              position: absolute;
              width: 5px;
              height: 5px;
              background: #9e070e;
              border-radius: 50%;
              left: 24px;
            }

            span {
              &:nth-child(1) {
                color: #333;

                &:hover {
                  cursor: pointer;
                  color: #AB070E;
                }
              }

              &:nth-child(2) {
                font-size: 14px;
                color: #999;
              }
            }
          }
        }
      }
    }
  }
}

// 中间内容
.mid {
  height: 453px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .mid_ {
    width: 375px;
    height: 350px;
    border: 1px solid #eee;
    background: #fff;

    .mid_title {
      padding: 0 20px;
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        &:nth-child(1) {
          font-size: 24px;
          color: #444;
          line-height: 54px;
          position: relative;

          &::after {
            content: "";
            position: absolute;
            width: 100%;
            height: 2px;
            background: #8d080e;
            bottom: 2px;
            left: 0;
          }
        }

        &:nth-child(2) {
          color: #666;

          &:hover {
            cursor: pointer;
            color: #8D080E;
          }
        }
      }
    }

    .mid_list {
      height: 280px;
      padding: 0 20px;
      overflow: hidden;

      ul {
        width: 100%;
        height: 100%;
        padding-top: 10px;

        li {
          display: flex;
          justify-content: space-around;
          align-items: center;
          height: 45px;
          padding-left: 20px;
          position: relative;
          border-bottom: 1px solid #eee;
          line-height: 45px;

          span {
            width: 100%;
            color: #333;
            display: block;
            text-decoration: none;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 15px;

            &:hover {
              cursor: pointer;
              color: #8D080E;
            }

            &::after {
              content: "";
              position: absolute;
              width: 5px;
              height: 5px;
              background: #8d080e;
              border-radius: 50%;
              left: 0;
              top: 50%;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personnel/personnel.vue